import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { BaseResponse } from '../../responses/BaseResponse';
import { ContactRequest } from '../../requests/ContactRequest';
import { SubscribeRequest } from '../../requests/SubscribeRequest';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  baseUrl = environment.baseUrl;

  constructor(private readonly http: HttpClient) {}

  public insertContact(contactRequest: ContactRequest): Observable<BaseResponse> {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };

    return this.http.post<BaseResponse>(`${this.baseUrl}web/new-contact`, contactRequest, { headers }).pipe(
      catchError((error:any) => throwError(() => error))
    );
  }

  public subscribeEmail(subscribeRequest: SubscribeRequest): Observable<BaseResponse> {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };

    return this.http.post<BaseResponse>(`${this.baseUrl}web/subscribe`, subscribeRequest, { headers }).pipe(
      catchError((error:any) => throwError(() => error))
    );
  }
}
